export const LOCAL_STORAGE = 'LOCAL_STORAGE';
export const SESSION_STORAGE = 'SESSION_STORAGE';
export const COOKIE_STORAGE = 'COOKIE_STORAGE';

export const storageKeys = {
  USER_PARAMS: 'userParams',
  TRANSACTION_PARAMS: 'transactionParams',
};
